import React, { useEffect } from 'react'
import { navigate } from 'gatsby'

// Hooks
import useLayout from 'hooks/useLayout'
import { LayoutContextProps } from 'components/layout/Layout'

// Third Party
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

interface SwitchLocaleProps {
  isSticky?: boolean
}

const Switch = styled(motion.div)<{ isSticky?: boolean }>`
  height: 13px;
  width: 13px;

  border-radius: 100%;

  ${(props) =>
    props.isSticky
      ? css`
          background-color: ${({ theme }) => theme.color.light};
        `
      : css`
          background-color: ${({ theme }) => theme.color.secondary};
        `}
`

const SwitchWrapper = styled(motion.div)<{ isSticky?: boolean }>`
  border-radius: 20px;
  width: 30px;
  height: 17px;
  display: flex;
  align-items: center;
  padding: 0px 4px;
  cursor: pointer;

  ${(props) =>
    props.isSticky
      ? css`
          background-color: ${({ theme }) => theme.color.primary} !important;
        `
      : css`
          background-color: ${({ theme }) => theme.color.light};
        `}
`

const Lang = styled.div<{ isSticky?: boolean }>`
  font-family: ${({ theme }) => theme.font.family.secondary};
  font-size: 14px;

  ${(props) =>
    props.isSticky
      ? css`
          color: ${({ theme }) => theme.color.primary} !important;
        `
      : css`
          color: ${({ theme }) => theme.color.light};
        `}
`

const SwitchLocale: React.FC<SwitchLocaleProps> = ({ isSticky }) => {
  const layout: LayoutContextProps = useLayout()

  if (layout.translations && layout.translations.length < 1) return null

  const switchLocale = (findLocale: string): void => {
    if (layout.translations && layout.translations.length > 0) {
      const translation = layout.translations.find(
        ({ locale }: any) => locale === findLocale
      )

      if (translation) {
        let goTo = translation.href

        if (goTo.indexOf('/sample-page/') !== -1) {
          goTo = `/${goTo.split('/')[1]}`
        }

        if (goTo === '/de/home/') {
          goTo = `/${goTo.split('/')[1]}/`
        }

        // On Development the URI for the "main" homepage is an absolute one, which is why we have to set it manually
        if (goTo === 'https://uwbusinessonline.site/aeriusmarine.admin') {
          goTo = '/'
        }

        if (typeof window !== `undefined`) {
          localStorage.setItem('locale', translation.locale)
          layout.setLocalLanguage(localStorage.getItem('locale'))
        }

        navigate(goTo)
      }
    }
  }

  return (
    <div style={{ marginTop: 1 }}>
      <div className="d-flex align-items-center">
        <Lang className="me-1" isSticky={isSticky}>
          EN
        </Lang>
        <SwitchWrapper
          onClick={() =>
            switchLocale(layout.locale === 'en_US' ? 'de_DE' : 'en_US')
          }
          animate={
            layout.locale === 'en_US'
              ? { justifyContent: 'flex-start' }
              : { justifyContent: 'flex-end' }
          }
          isSticky={isSticky}
        >
          <Switch isSticky={isSticky} />
        </SwitchWrapper>
        <Lang className="ms-1" isSticky={isSticky}>
          DE
        </Lang>
      </div>
    </div>
  )
}

export default SwitchLocale
